<template>
    <!-- 一键清楚违禁词-失败弹窗 -->
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="820px"
        append-to-body
        :before-close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <template v-if="topErrorTip != ''"><div v-html="topErrorTip"></div></template
        ><template v-else
            ><span
                >一共修改<span class="red">{{ data.totalCount }}</span
                >条数据，其中<span class="red">{{ data.failCount }}</span
                >条数据修改失败</span
            ></template
        >
        <slot name="topEvent"></slot>
        <el-table
            v-loading="loading"
            class="resetStyle"
            max-height="320px"
            :data="data.tableData"
            border
            style="width: 99.9%; margin-top: 20px"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255,255,255,0)"
        >
            <el-table-column type="index" label="序号" width="75" />
            <el-table-column prop="Title" label="标题" />
            <el-table-column prop="Tips" label="失败原因" width="320">
                <template #default="{ row }">
                    <span v-html="row.Tips"></span>
                    <slot name="btnEvent" :data="row.data"></slot
                ></template>
            </el-table-column>
            <el-table-column v-if="showOperation" label="操作" width="75">
                <template #default="{ row }">
                    <span class="curp" style="color: #0064c1" @click="modifyFailed(row.OfferId)">修改</span></template
                >
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
let options;
export default {
    name: 'FailList',
    data() {
        return {
            title: '失败列表',
            dialogVisible: false,
            loading: false,
            data: {
                tableData: [],
                totalCount: 0,
                failCount: 0,
            },
            topErrorTip: '',
            showOperation: true,
        };
    },
    mounted() {},
    methods: {
        show(opts) {
            options = {
                title: '失败列表',
                topErrorTip: '',
                tableData: [],
                totalCount: 0,
                failCount: 0,
                close: undefined,
            };
            options = Object.assign(options, opts);
            this.title = options.title;
            this.data.tableData = options.tableData;
            this.topErrorTip = options.topErrorTip;
            this.data.totalCount = options.totalCount;
            this.data.failCount = options.failCount;
            this.showOperation = options.showOperation;
            this.dialogVisible = true;
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    done();
                    options.close && options.close();
                })
                .catch(() => {});
        },
        modifyFailed(OfferId) {
            this.loading = true;
            this.$ajax
                .post('api/tiktok/Product/SearchListV2', {
                    productIdStr: OfferId + '',
                    pageIndex: 1,
                    pageSize: 10,
                })
                .then((res) => {
                    this.loading = false;
                    if (res.code === 200 && res.result.list.length !== 0) {
                        this.$emit('modifyFailed', OfferId);
                        this.dialogVisible = false;
                    } else {
                        this.$message.warning('该产品已被删除，不支持修改');
                    }
                });
            // this.$emit()
        },
    },
};
</script>

<style lang="scss" scoped>
.red {
    color: #ff0000;
}
.btn-box {
    text-align: center;
    margin-top: 20px;
    button {
        margin: 0 5px;
    }
}
</style>
